import React from 'react';
import Header from './header';
import LoadingPage from '../pages/Loading';
import { SettingsProps, DataDetailCheckout, ErrorResponse } from '@pages/types';
import { IconCircleX } from '@tabler/icons-react';
import SuccessResult from '@pages/ComponentsPage/SuccessResult';

type LayoutProps = {
  children: React.ReactNode;
  isLoading?: boolean;
  summarySlot?: React.ReactNode;
  data: DataDetailCheckout;
  settings?: SettingsProps;
  error?: ErrorResponse;
};

const Layout: React.FC<LayoutProps> = ({
  children,
  isLoading,
  summarySlot,
  data,
  settings,
  error,
}) => {
  if (error) {
    return (
      <div className="min-h-screen overflow-x-hidden bg-neutral-100">
        <Header />
        <main className="overflow-hidden pb-10">
          <div className="mx-auto w-full max-w-2xl">
            <div className="mt-4 flex h-fit items-center justify-center rounded-xl bg-white px-4 shadow-sm sm:px-6 lg:px-8">
              <div className="flex w-full flex-col gap-8 px-4 pb-6 pt-8 lg:px-0">
                <div className="flex flex-col items-center gap-6">
                  <div className="mx-auto w-fit">
                    <div className="flex h-20 w-20 items-center justify-center rounded-full border-4 border-gray-700 bg-gray-500">
                      <IconCircleX className="h-[76px] w-[76px] text-white" />
                    </div>
                  </div>
                  <div className="flex flex-col items-center gap-1">
                    <span className="text-3xl font-semibold text-gray-700">
                      Payment Expired
                    </span>
                    <span className="text-base font-normal text-gray-700">
                      Your transaction was unsuccessful.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="min-h-screen overflow-x-hidden bg-neutral-100">
        <Header />
        <main className="-mt-[73px] h-[calc(100vh-80px)] overflow-hidden">
          <LoadingPage settings={settings} />
        </main>
      </div>
    );
  }

  const paymentStatus = data?.status;
  const isSuccess =
    paymentStatus && String(paymentStatus).toUpperCase() === 'PAID';
  const isFailed =
    paymentStatus && String(paymentStatus).toUpperCase() === 'CANCELLED';

  if (isSuccess || isFailed) {
    return (
      <div className="min-h-screen overflow-x-hidden bg-neutral-100">
        <Header />
        <main className="overflow-hidden pb-10">
          <SuccessResult data={data} settings={settings} />
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen overflow-x-hidden bg-white">
      <Header />
      <main className="h-[calc(100vh-80px)] overflow-hidden">
        <div className="container mx-auto h-full px-2 sm:px-2 lg:px-8">
          <div className="grid h-full grid-cols-1 gap-0 lg:grid-cols-10">
            <div className="flex h-full justify-center overflow-y-auto pb-10 pt-0 md:col-span-6 md:pt-8">
              <div className="w-full max-w-2xl">{children}</div>
            </div>

            {summarySlot ? summarySlot : null}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Layout;
